module.exports = __webpack_public_path__ + "static/media/specialist.d4728443.jpg";